import { render, staticRenderFns } from "./PermohonanUMK.vue?vue&type=template&id=adfa351c&"
import script from "./PermohonanUMK.vue?vue&type=script&lang=js&"
export * from "./PermohonanUMK.vue?vue&type=script&lang=js&"
import style0 from "./PermohonanUMK.vue?vue&type=style&index=0&id=adfa351c&prod&lang=css&"
import style1 from "./Elements.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports